export const AnnexTabList = [
  { id: 0, label: "История" },
  { id: 1, label: "Вложения" },
];
